<script lang="ts">
	import { Button } from '@Shelly/shelly-design-system';
	import { save_profile } from 'src/helpers/profile_helpers';
	import { resetWhatsNewSeenOnDevice } from 'src/helpers/whats_new_helpers';

	const updateWhatsNewFeaturesTimestamp = () => {
		save_profile('whatsNew', 1680455849);
		resetWhatsNewSeenOnDevice();
	};
</script>

<Button on:click={updateWhatsNewFeaturesTimestamp}>Reset What's New Features</Button>
